import React from 'react'
import { Typography } from '~/components/_atoms'
import { useTranslation } from '~/hooks/useTranslation'

const ItalianChatHelp = () => {
  const { t } = useTranslation()
  const serviceList = t('live_chat.italian_chat_help.service_list', {
    returnObjects: true,
  })

  return (
    <div className="pb-10 pl-8">
      <Typography variant="h6" color="secondary" className="font-semibold">
        {t('live_chat.italian_chat_help.how_consultants_can_help')}
      </Typography>
      <Typography variant="body1" color="secondary" className="pt-2">
        {t('live_chat.italian_chat_help.description')}
      </Typography>
      <ul className="list-inside list-disc pt-2">
        {serviceList.map((service) => (
          <li key={service}>{service}</li>
        ))}
      </ul>
    </div>
  )
}

export default ItalianChatHelp
